export const isSignUpChannel = (value)=>value === "phone" || value === "kakao" || value === "whale";
export const getChannelDialogContent = (param)=>{
    let { channel , maskedPhone , maskedEmail  } = param;
    switch(channel){
        case "phone":
            return {
                title: "휴대폰 번호로 가입되어 있어요.",
                content: "로그인 페이지에서 ‘휴대폰 번호로 로그인’ 버튼을 클릭해주세요.",
                maskedPhone
            };
        case "kakao":
            return {
                title: "카카오로 가입되어 있어요.",
                content: "로그인 페이지에서 ‘카카오 로그인’ 버튼을 클릭해주세요.",
                maskedEmail
            };
        case "whale":
            return {
                title: "웨일로 가입되어 있어요.",
                content: "로그인 페이지에서 웨일 로그인을 진행해주세요."
            };
    }
};
// mixpanel 'Popup Type' 값. channel → '기존 가입 유저(휴대폰|카카오|웨일)'
export const getChannelPopupType = (channel)=>{
    switch(channel){
        case "phone":
            return "기존 가입 유저(휴대폰)";
        case "kakao":
            return "기존 가입 유저(카카오)";
        case "whale":
            return "기존 가입 유저(웨일)";
    }
};
